import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControlLabel,
  Checkbox,
  Button,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const EditAorDialog = ({
  open,
  onClose,
  quantityReceived,
  setQuantityReceived,
  materialConform,
  setMaterialConform,
  comment,
  setComment,
  onSave,
}) => {
  const { t } = useTranslation();

  const handleSave = () => {
    if (!materialConform && !comment.trim()) {
      return; // Prevent saving if the comment is mandatory and empty
    }
    onSave();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t("editAor")}</DialogTitle>
      <DialogContent>
        <TextField
          type="number"
          label={t("quantityReceived")}
          value={quantityReceived}
          onChange={(e) => {
            const value = Math.max(0, Number(e.target.value));
            setQuantityReceived(value);
          }}
          fullWidth
          sx={{ mt: 2 }}
          InputProps={{
            inputProps: { min: 0 },
          }}
          InputLabelProps={{
            style: {
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            },
          }}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={materialConform}
              onChange={(e) => setMaterialConform(e.target.checked)}
            />
          }
          label={t("materialConform")}
        />
        {!materialConform && (
          <TextField
            label={t("describeError")}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            fullWidth
            multiline
            rows={3}
            sx={{ mt: 2 }}
            error={!comment.trim()}
            helperText={!comment.trim() ? t("commentMandatory") : ""}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" variant="outlined">
          {t("cancel")}
        </Button>
        <Button onClick={handleSave} color="primary" variant="contained">
          {t("save")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditAorDialog;